import type { HTMLAttributes, FC } from 'react';

import { cn } from './cn.js';

/** Тон бейджа. Имена совпадают со статусами отгрузки из макета плюс нейтральный. */
export type BadgeTone =
  | 'neutral'
  | 'plan'
  | 'approval'
  | 'preparing'
  | 'delivery'
  | 'payment'
  | 'completed'
  | 'delayed'
  | 'cancelled'
  | 'returned';

const TONE: Record<BadgeTone, string> = {
  neutral: 'bg-ink-100 text-ink-600',
  plan: 'bg-st-plan-bg text-st-plan',
  approval: 'bg-st-approval-bg text-st-approval',
  preparing: 'bg-st-preparing-bg text-st-preparing',
  delivery: 'bg-st-delivery-bg text-st-delivery',
  payment: 'bg-st-payment-bg text-st-payment',
  completed: 'bg-st-completed-bg text-st-completed',
  delayed: 'bg-st-delayed-bg text-st-delayed',
  cancelled: 'bg-st-cancelled-bg text-st-cancelled',
  returned: 'bg-st-returned-bg text-st-returned',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** Точка слева от текста - как у .badge .dot в макете. */
  withDot?: boolean;
}

export const Badge: FC<BadgeProps> = ({
  tone = 'neutral',
  withDot = false,
  className,
  children,
  ...rest
}) => (
  <span
    className={cn(
      'inline-flex h-[22px] items-center gap-1.5 rounded-full px-2 text-[11.5px] font-[550] whitespace-nowrap',
      TONE[tone],
      className,
    )}
    {...rest}
  >
    {withDot && (
      <span
        aria-hidden
        className="inline-block size-1.5 shrink-0 rounded-full bg-current opacity-90"
      />
    )}
    {children}
  </span>
);
